import { Select, Textarea, type TypeSelectOption } from '@thefarmersfront/kitchen';

import { FormField } from '~/components/common';

import { DELIVERY_AGENCY_LOCATION_DETAIL_MAX_LENGTH } from '~/constants';

type TypeDeliveryAgencyOrderLocationFieldProps = {
  /** 편집 가능 여부 (주문 상태 기준) */
  editable: boolean;
  /** 장소/방법 Select */
  selectLabel: string;
  selectOptions: TypeSelectOption<string>[];
  selectValue: TypeSelectOption<string> | null;
  selectError: boolean;
  onSelectChange: (event: unknown, value: TypeSelectOption<string>) => void;
  /** 상세 Textarea */
  detailLabel: string;
  detailRequired: boolean;
  detailValue: string;
  detailError: boolean;
  detailRef: React.RefObject<HTMLTextAreaElement | null>;
  onDetailChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onDetailBlur: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
};

/**
 * [배송 주문 상세] 수령장소/출입방법 + 상세 편집 행.
 * 장소 Select 와 그에 종속된 조건부 필수 상세 Textarea 한 쌍을 렌더한다.
 */
const DeliveryAgencyOrderLocationField = ({
  editable,
  selectLabel,
  selectOptions,
  selectValue,
  selectError,
  onSelectChange,
  detailLabel,
  detailRequired,
  detailValue,
  detailError,
  detailRef,
  onDetailChange,
  onDetailBlur,
}: TypeDeliveryAgencyOrderLocationFieldProps) => {
  return (
    <>
      <FormField
        label={selectLabel}
        required
        contentAlign="center"
        contents={
          <Select
            size="small"
            placeholder="선택"
            options={selectOptions}
            value={selectValue}
            disabled={!editable}
            status={selectError ? 'error' : 'default'}
            validationMessage={selectError ? '필수 선택입니다.' : undefined}
            onChange={onSelectChange}
          />
        }
      />
      <FormField
        label={detailLabel}
        required={detailRequired}
        contents={
          <Textarea
            ref={detailRef}
            size="small"
            height="100px"
            placeholder="상세내용을 입력하세요."
            count
            maxLength={DELIVERY_AGENCY_LOCATION_DETAIL_MAX_LENGTH}
            value={detailValue}
            disabled={!editable}
            status={detailError ? 'error' : 'default'}
            validationMessage={detailError ? '필수 입력입니다.' : undefined}
            onChange={onDetailChange}
            onBlur={onDetailBlur}
          />
        }
      />
    </>
  );
};

export default DeliveryAgencyOrderLocationField;
